import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SearchDialog from './SearchDialog';
import useApi from '../../api/hooks/useApi';

// 전역 캐시 (CommonFilterSection과 공유)
const globalCache = {
    buyers: null,
    loading: {
        buyers: false
    }
};

const BuyerSearchDialog = ({ open, onClose, onSelect, initialValue = '' }) => {
    const { t } = useTranslation();
    const api = useApi();
    const [buyers, setBuyers] = useState([]);
    const [loading, setLoading] = useState(false);

    // 구매자 데이터 가져오기
    const fetchBuyers = async () => {
        if (globalCache.buyers || globalCache.loading.buyers) return; // 전역 캐시 확인
        
        globalCache.loading.buyers = true;
        setLoading(true);
        try {
            console.log('fetchBuyers');
            const response = await api.get('/info/v2/buyer/list');
            if (response.data) {
                globalCache.buyers = response.data;
                setBuyers(response.data);
            }
        } catch (error) {
            console.error('구매자 데이터 가져오기 실패:', error);
            // 첨부 이미지의 데이터 구조를 반영한 임시 데이터
            const tempBuyers = [
                { 
                    partner_id: 300501, 
                    partner_name: 'WALMART D33 GIRLS BOTTOM S2\'23',
                    partner_code: 200024,
                    partner_group: 'WALMART',
                    specification: '-',
                    biz_reg_no: null,
                    boss_name: null,
                    biz_cat1: null,
                    biz_cat2: null,
                    postcode: null,
                    address1: null,
                    address2: null,
                    creator_region: 'indonesia',
                    created_by: 'test4454',
                    created_at: '2025-03-05T13:55:13.533739'
                },
                { 
                    partner_id: 300502, 
                    partner_name: 'WALMART D34 YOUNG ADULT',
                    partner_code: 200025,
                    partner_group: 'WALMART',
                    specification: '-',
                    biz_reg_no: null,
                    boss_name: null,
                    biz_cat1: null,
                    biz_cat2: null,
                    postcode: null,
                    address1: null,
                    address2: null,
                    creator_region: 'indonesia',
                    created_by: 'test4454',
                    created_at: '2025-03-05T13:56:57.016523'
                }
            ];
            globalCache.buyers = tempBuyers;
            setBuyers(tempBuyers);
        } finally {
            globalCache.loading.buyers = false;
            setLoading(false);
        }
    };

    // 다이얼로그가 열릴 때 데이터 로드
    useEffect(() => {
        if (open) {
            // 전역 캐시에서 데이터가 있으면 먼저 설정
            if (globalCache.buyers) {
                setBuyers(globalCache.buyers);
            } else if (!globalCache.loading.buyers) {
                // 캐시에 데이터가 없고 로딩 중이 아니면 API 호출
                fetchBuyers();
            }
        }
    }, [open]);

    const columns = [
        { key: 'partner_code', label: t('buyers.fields.buyerCode') },
        { key: 'partner_name', label: t('buyers.fields.buyerName') },
        { key: 'partner_group', label: t('buyers.fields.buyerGroup') }
    ];

    const renderRow = (buyer, StyledTableRow, BodyCell, handleRowClick) => (
        <StyledTableRow
            key={buyer.partner_id}
            onClick={() => handleRowClick(buyer)}
            aria-label={`${buyer.partner_name} (${buyer.partner_code || '-'})`}
        >
            <BodyCell>{buyer.partner_code || '-'}</BodyCell>
            <BodyCell>{buyer.partner_name}</BodyCell>
            <BodyCell>{buyer.partner_group || '-'}</BodyCell>
        </StyledTableRow>
    );

    const customFilter = (data, searchTerm) => {
        // 검색어가 없으면 전체 데이터 반환
        if (!searchTerm || searchTerm.trim() === '') {
            return data;
        }

        const searchTermLower = searchTerm.toLowerCase();
        return data.filter(buyer => {
            const partnerCode = buyer.partner_code?.toString().toLowerCase() || '';
            const partnerName = buyer.partner_name?.toLowerCase() || '';
            const partnerGroup = buyer.partner_group?.toLowerCase() || '';
            return (
                partnerCode.includes(searchTermLower) || 
                partnerName.includes(searchTermLower) ||
                partnerGroup.includes(searchTermLower)
            );
        });
    };

    return (
        <SearchDialog
            open={open}
            onClose={onClose}
            onSelect={onSelect}
            initialValue={initialValue}
            allData={buyers}
            title={t('common.search')}
            placeholder={t('buyers.searchPlaceholder')}
            searchKeys={['partner_code', 'partner_name', 'partner_group']}
            columns={columns}
            renderRow={renderRow}
            customFilter={customFilter}
            listTitle={t('buyers.list.title')}
            isLoading={loading}
        />
    );
};

export default BuyerSearchDialog;